import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
	init() {},
	finalize() {
		//animation / gsap
		// planes
		let $oddPlanes = $(
			'.fleet-wrap .coastal-text-media-block:nth-of-type(odd) .white-line svg, .fleet-wrap .coastal-text-block:nth-of-type(odd) .white-line svg'
		)
		if ($oddPlanes.length) {
			document
				.querySelectorAll(
					'.fleet-wrap .coastal-text-media-block:nth-of-type(odd) .white-line svg, .fleet-wrap .coastal-text-block:nth-of-type(odd) .white-line svg'
				)
				.forEach((item) => {
					gsap.fromTo(
						item,
						{ x: 0 },
						{
							scrollTrigger: item,
							delay: 0,
							duration: 0.5,
							x: 110,
						}
					)
				})
		}
		let $evenPlanes = $(
			'.fleet-wrap .coastal-text-media-block:nth-of-type(even) .white-line svg, .fleet-wrap .coastal-text-block:nth-of-type(even) .white-line svg'
		)
		if ($evenPlanes.length) {
			document
				.querySelectorAll(
					'.fleet-wrap .coastal-text-media-block:nth-of-type(even) .white-line svg, .fleet-wrap .coastal-text-block:nth-of-type(even) .white-line svg'
				)
				.forEach((item) => {
					gsap.fromTo(
						item,
						{ x: 0 },
						{
							scrollTrigger: item,
							delay: 0,
							duration: 0.5,
							x: -150,
						}
					)
				})
		}

		//coastal text & media block
		let $oddMediaBlock = $(
			'.fleet-wrap .coastal-text-media-block:nth-of-type(odd)'
		)
		if ($oddMediaBlock.length) {
			document
				.querySelectorAll(
					'.fleet-wrap .coastal-text-media-block:nth-of-type(odd)'
				)
				.forEach((item) => {
					gsap.fromTo(
						item,
						{ x: 50, opacity: 0 },
						{
							scrollTrigger: item,
							delay: 0.5,
							duration: 0.5,
							x: 0,
							opacity: 1,
						}
					)
				})
		}

		let $evenMediaBlock = $(
			'.fleet-wrap .coastal-text-media-block:nth-of-type(even)'
		)
		if ($evenMediaBlock.length) {
			document
				.querySelectorAll(
					'.fleet-wrap .coastal-text-media-block:nth-of-type(even)'
				)
				.forEach((item) => {
					gsap.fromTo(
						item,
						{ x: -50, opacity: 0 },
						{
							scrollTrigger: item,
							delay: 0.5,
							duration: 0.5,
							x: 0,
							opacity: 1,
						}
					)
				})
		}
	},
}
